var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDuplicate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 10.6666V13.3333C10.6667 14.1015 10.1016 14.6666 9.33337 14.6666H2.66671C1.89852 14.6666 1.33337 14.1015 1.33337 13.3333V6.66665C1.33337 5.89846 1.89852 5.33331 2.66671 5.33331H5.33337V2.66665C5.33337 1.89846 5.89852 1.33331 6.66671 1.33331H13.3334C14.1016 1.33331 14.6667 1.89846 14.6667 2.66665V9.33331C14.6667 10.1015 14.1016 10.6666 13.3334 10.6666H10.6667ZM9.33337 10.6666H6.66671C5.89852 10.6666 5.33337 10.1015 5.33337 9.33331V6.66665H2.66671V13.3333H9.33337V10.6666ZM6.66671 2.66665V9.33331H13.3334V2.66665H6.66671Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDuplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/duplicate.5337e22e.svg";
export { ForwardRef as ReactComponent };